import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserProjectHubList } from "../../api/project";

type UserProjectOverviewProps = {
  projectCode: string;
};

export default function UserProjectOverview({
  projectCode,
}: UserProjectOverviewProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [userProjectHub, setUserProjectHub] = useState(0);
  const { t } = useTranslation();

  const fetchUserProjectHub = async (controller: AbortController) => {
    try {
      setIsLoading(true);
      const result = await getUserProjectHubList(projectCode, controller);
      setUserProjectHub(result);
      setIsLoading(false);
    } catch (e: unknown) {
      if (e instanceof Error) {
        if (e.name === "AbortError") console.log("Request aborted!");
      } else console.error(e);
    }
  };
  useEffect(() => {
    let controller = new AbortController();
    fetchUserProjectHub(controller);
    return () => controller.abort();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        borderRadius: 5,
        border: 1,
      }}
    >
      <Box padding={2} sx={{ width: "90%", textAlign: "center" }}>
        <Typography variant="h5">{t("userProjectOverview.text1")}</Typography>
        <Typography variant="h5">{t("userProjectOverview.text2")}</Typography>
        <Typography variant="h5">{projectCode}</Typography>
        {isLoading ? (
          <CircularProgress sx={{ marginTop: 2 }} />
        ) : (
          <Typography variant="h3" color="primary" m={2}>
            {userProjectHub}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
